__turbopack_context__.v({
  "contentWrapper": "Trees-module__TxHXOa__contentWrapper",
  "countWrapper": "Trees-module__TxHXOa__countWrapper",
  "description": "Trees-module__TxHXOa__description",
  "gradient": "Trees-module__TxHXOa__gradient",
  "header": "Trees-module__TxHXOa__header",
  "headerBackground": "Trees-module__TxHXOa__headerBackground",
  "hideSlideInfo": "Trees-module__TxHXOa__hideSlideInfo",
  "introHeader": "Trees-module__TxHXOa__introHeader",
  "joinNow": "Trees-module__TxHXOa__joinNow",
  "learnMore": "Trees-module__TxHXOa__learnMore",
  "progressBarContainer": "Trees-module__TxHXOa__progressBarContainer",
  "progressBarFill": "Trees-module__TxHXOa__progressBarFill",
  "showSlideInfo": "Trees-module__TxHXOa__showSlideInfo",
  "slide": "Trees-module__TxHXOa__slide",
  "slide1": "Trees-module__TxHXOa__slide1",
  "slide2": "Trees-module__TxHXOa__slide2",
  "slide3": "Trees-module__TxHXOa__slide3",
  "slide4": "Trees-module__TxHXOa__slide4",
  "slideDownBounce": "Trees-module__TxHXOa__slideDownBounce",
  "slideInfo": "Trees-module__TxHXOa__slideInfo",
  "slideUpBounce": "Trees-module__TxHXOa__slideUpBounce",
  "slideWrapper": "Trees-module__TxHXOa__slideWrapper",
  "title": "Trees-module__TxHXOa__title",
  "treeCount": "Trees-module__TxHXOa__treeCount",
  "treeInfoSlides": "Trees-module__TxHXOa__treeInfoSlides",
  "treeStatText": "Trees-module__TxHXOa__treeStatText",
  "treeStats": "Trees-module__TxHXOa__treeStats",
  "trees": "Trees-module__TxHXOa__trees",
  "treesHeaderText": "Trees-module__TxHXOa__treesHeaderText",
});
